<template>
  <div class="home">
     <v-head></v-head>
     <!--<div id="iSlider-wrapper"></div>-->
    <!-- Swiper -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="b in banner_list"  ><a v-link="{name:'slide', params: { id: b.id}}"><img :src="b.image" alt=""></a></div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
     <div class="home_content clearfix">
       <div>
         <a v-link="{name:'n_select', params: { name: winer.ids}}">
           <img :src="winer.imgs" alt="">
         </a>
       </div>
       <div class="home_content_two">
         <span>
           <a v-link="{path:'/micro'}"><img :src="index_right_top" alt=""></a>
         </span>
         <span>
           <a v-link="{path:'/crossover'}"><img :src="index_right_middle" alt=""></a>
         </span>
         <span>
           <a v-link="{path:'/walkin'}"><img src="../../../static/images/20150312105358251.gif" alt=""></a>
         </span>
       </div>
     </div>
     <v-footer></v-footer>


  </div>
</template>

<script id="show-code">
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return{
          banner_list:[],
          index_right:[],
          index_left:"",
          index_right_top:"",
          index_right_middle:"",
          index_right_bottom:"",
          winer:{
            ids:"",
            imgs:""
          }

      }
    },
    components: {
      "v-head":head,
      "v-footer":footer,
    },
    ready() {
      var _this = this;
      var url = "http://112.74.184.45:882/";
      var variate = [];
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsByTypeId/97",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
              console.log(2563214,data);
            /*for(var i = 0;i<data.data.length;i++){
              variate = url + data.data[i].src;
              _this.banner_list.push(variate);
            }*/
            _this.banner_list = data.data;
            _this.$nextTick(function () {
              var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                loop : true,
                autoplay : 2000,
                grabCursor : true,
              });
            });
          }
        },
      });
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsByTypeId/92",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            for(var i = 0;i<data.data.length;i++){
              _this.index_right_middle = data.data[2].image;
              _this.index_right_bottom = data.data[0].image;
              _this.index_right_top = data.data[1].image;
            }
          }
        }
      });
      /*$.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getImageByTypeId/29",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            for(var i = 0;i<data.data.length;i++){
              _this.index_left = data.data[0].src;
            }
          }
        },
      });*/
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/29",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            _this.winer.imgs = data.image;
            _this.winer.ids = data.id;
          }
        }
      });

    },
    computed () {

    }

  }
</script>

<style>
  .home{width: 9rem; margin: 0 auto;}
  .home_content{width:9rem;margin-top: 0.2rem}
  .home_content div:first-child{float: left;width: 4.45rem; margin-right: 0.1rem;}
  .home_content div:last-child{float: right;width: 4.45rem}
  .home_content img{width: 100%}
  .home_content_two{width:4.45rem;float: left}
  .home_content_two span{width: 4.45rem;display:inline-block;margin-bottom: 0.05rem;}
  /*ul wrapper*/
  /*#iSlider-wrapper {  height: 4rem;overflow: hidden;max-width: 9rem;margin-top: 0.5rem}
  #iSlider-wrapper ul {  list-style: none;  margin: 0;  padding: 0;  height: 100%;  overflow: hidden;  }
  #iSlider-wrapper li {  position: absolute;  margin: 0;  padding: 0;  height: 100%;  overflow: hidden;  display: -webkit-box;  -webkit-box-pack: center;  -webkit-box-align: center;  list-style: none;  }
  #iSlider-wrapper li img {  width: 100%;  height: 100%;  }
  .islider-dot-wrap{  width: 80%;  height: 10%;  margin: 0 auto;  position: absolute;  padding: 0;  left: 0;  right: 0;  top: 1.7rem;  z-index: 10000;  text-align: center;}*/
  .swiper-container {  width: 100%;  height: 100%;margin-top: 0.5rem  }
  .swiper-slide {  text-align: center;  font-size: 18px;  background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  @media screen and (max-width: 30em) and (min-width:20em ){
   .home{width: 100%}
    /*#iSlider-wrapper{width: 100%;height: 2rem}*/
    .swiper-container {  width: 100%;  height: 100%;margin-top: 0.5rem  }
    .swiper-container img{width: 100%;height: 100%  }
    .home_content{width: 100%;margin-top: 0.1rem}
    .home_content div:first-child{width: 100%}
    .home_content div:last-child{width: 100%}
    .home_content_two{width:100%;float: left}
    .home_content_two span{width: 100%;display:inline-block;margin-bottom: 0.05rem;}
  }
</style>



// WEBPACK FOOTER //
// home.vue?b7cfa296